import { articles } from '@/mocks/articles';
import ArticleLayout from '@/pages/article/components/ArticleLayout';

export default function ArticleModa() {
  const article = articles.find((a) => a.slug === 'itaobuy-spreadsheet-moda-streetwear')!;
  return <ArticleLayout article={article} />;
}